
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.273 5.09h1.502a3.806 3.806 0 003.589 2.546c1.667 0 3.054-1.069 3.589-2.545h14.229c.7 0 1.273-.573 1.273-1.273s-.573-1.273-1.273-1.273h-14.23A3.806 3.806 0 007.365 0c-1.668 0-3.055 1.07-3.59 2.545H2.274c-.7 0-1.273.573-1.273 1.273s.573 1.273 1.273 1.273zM25.182 22.91h-14.23a3.806 3.806 0 00-3.588-2.546c-1.668 0-3.055 1.069-3.59 2.545H2.274c-.7 0-1.273.573-1.273 1.273s.573 1.273 1.273 1.273h1.502A3.806 3.806 0 007.364 28c1.667 0 3.054-1.07 3.589-2.546h14.229c.7 0 1.273-.572 1.273-1.272 0-.7-.573-1.273-1.273-1.273zM25.182 12.727H23.68a3.806 3.806 0 00-3.59-2.545c-1.666 0-3.054 1.069-3.588 2.545H2.272C1.573 12.727 1 13.3 1 14s.573 1.273 1.273 1.273h14.229a3.806 3.806 0 003.589 2.545c1.667 0 3.054-1.069 3.589-2.545h1.502c.7 0 1.273-.573 1.273-1.273s-.573-1.273-1.273-1.273z","fill":"#1d4ed8"}})])
          )
        }
      }
    